module.exports = __webpack_public_path__ + "img/optional_sum_assured.cdc6cb8.svg";